((app) => {

    app.service("modalService",
        [
            "$mdDialog", "$state", function ($mdDialog, $state) {
                const defaults = {
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    bindToController: true
                };

                this.confirmDeleteClient = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        targetEvent: $event,
                        theme: "confirmDelete",
                        templateUrl: "/App/Modals/DeleteClient/confirmdeleteclient-template.html",
                        ariaLabel: "Confirm client deletion",
                        ok: "Delete",
                        cancel: "Cancel"
                    });

                    return $mdDialog.show(confirm);
                };

                this.confirmCaseDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        theme: "confirmDelete",
                        targetEvent: $event,
                        title: "Are you sure you want to delete this case?",
                        textContent: 'All existing accounts belong to this case will also be deleted for all users. This action is permanent.',
                        ariaLabel: "Confirm case deletion",
                        ok: "Delete",
                        cancel: "Cancel"
                    });

                    return $mdDialog.show(confirm);
                };

                this.confirmAppointmentDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        targetEvent: $event,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this appointment?",
                        ariaLabel: "Confirm appointment deletion",
                        ok: "Delete",
                        cancel: "Cancel"
                    });

                    return $mdDialog.show(confirm);
                };

                this.confirmScheduledTaskDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        targetEvent: $event,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this task?",
                        ariaLabel: "Confirm task deletion",
                        ok: "Delete",
                        cancel: "Cancel"
                    });

                    return $mdDialog.show(confirm);
                };

                this.openImportContacts = (currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        templateUrl: "/App/Modals/ImportContacts/import-contacts.template.html",
                        controller: "importContactsController",
                        controllerAs: "$ctrl",
                        locals: {
                            currentUser
                        }
                    });

                    return $mdDialog.show(alert)
                        .finally(() => {
                            $state.reload();
                        });
                };

                this.openAddContact = (currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        templateUrl: "/App/Modals/AddContact/add-contact.html",
                        controller: "addContactController",
                        controllerAs: "$ctrl",
                        locals: {
                            currentUser
                        }
                    });

                    return $mdDialog.show(alert);
                };
                
                this.openAddCustomField = (currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        templateUrl: "/App/Modals/AddCustomField/add-custom-field-template.html",
                        controller: "addCustomFieldController",
                        controllerAs: "$ctrl",
                        locals: {
                            currentUser
                        }
                    });

                    return $mdDialog.show(alert);
                };

                this.openEditCustomField = (customField, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        templateUrl: "/App/Modals/EditCustomField/edit-custom-field-template.html",
                        controller: "editCustomFieldController",
                        controllerAs: "$ctrl",
                        locals: {
                            customField
                        }
                    });

                    return $mdDialog.show(alert);
                };

                this.confirmCustomFieldDeletion = (customFieldName, $event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        targetEvent: $event,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this custom field '" + customFieldName + "'? ",
                        ariaLabel: "Confirm field deletion",
                        ok: "Delete",
                        cancel: "Cancel"
                    });

                    return $mdDialog.show(confirm);
                };

                this.openAddAppointment = (client, currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        templateUrl: "/App/Modals/AddAppointment/add-appointment.html",
                        controller: "addAppointmentController",
                        controllerAs: "$ctrl",
                        locals: {
                            client,
                            currentUser
                        }
                    });

                    return $mdDialog.show(alert);
                };

                this.openAddScheduledTask = (client, currentUser, appointmentId, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        templateUrl: "/App/Modals/AddScheduledTask/add-scheduled-task.html",
                        controller: "addScheduledTaskController",
                        controllerAs: "$ctrl",
                        locals: {
                            client,
                            currentUser,
                            appointmentId
                        }
                    });

                    return $mdDialog.show(alert);
                };

                this.openFigAccountInfo = (arcPolicyGuid, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Modals/ExternalAccountInfo/fig-account-info.html",
                        controller: "figAccountController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        bindToController: true,
                        locals: {
                            arcPolicyGuid
                        }
                    });

                    return $mdDialog.show(alert);
                };

                this.openAcmAccountInfo = (acmAccountGuid, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Modals/ExternalAccountInfo/acm-account-info.html",
                        controller: "acmAccountController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        bindToController: true,
                        locals: {
                            acmAccountGuid
                        }
                    });

                    return $mdDialog.show(alert);
                };
            }
        ]);

})(window.app); //jshit ignore:line